import { Card, CardBody, Col, Input, InputGroup, InputGroupText } from "reactstrap";
import { CheckboxesAndRadiosTitle } from "../../../../../../Constants/Constants";
import { CheckBoxesAndRadiosSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const CheckboxesAndRadios = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={CheckboxesAndRadiosTitle} span={CheckBoxesAndRadiosSubTitle} />
        <CardBody className="checkbox-checked card-wrapper input-group-wrapper">
          <InputGroup>
            <InputGroupText>
              <Input className="mt-0" type="checkbox" />
            </InputGroupText>
            <Input type="text" />
          </InputGroup>
          <InputGroup>
            <InputGroupText>
              <Input className="mt-0" type="radio" defaultChecked />
            </InputGroupText>
            <Input type="text" />
          </InputGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CheckboxesAndRadios;
